module.exports = __webpack_public_path__ + "static/media/certificado_qrcode.774ec78f.png";